export const tokenAddress = "0x9eAeBd7E73D97E78c77fAB743e6FFA1b550e224c";
// export const preSaleAddress = "0x1fE2D3A7F5621aF20B7eF86A9975F960036F5928";
export const preSaleAddress = "0xa9502665b39b0e61F2CbbFfAD139688615fB16F6";
export const usdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
export const usdcAddress = "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48";
